import { makeStyles } from '@material-ui/core';
import { CartPiece } from 'components/WidgetInflationCart/WidgetInflationCart';
import React from 'react';

interface RecreationCardProps {
    card: CartPiece;
}

const useStyles = makeStyles((theme) => ({
    recreationCard: {
        backgroundColor: '#71C9CE',
        width: '298px',
        height: '363px',
        flexShrink: 0,
        borderRadius: '10px',
        padding: '20px',
        [theme.breakpoints.down('sm')]: {
            height: '300px',
        },
    },
    svg: {
        width: '66px',
        height: '60.963px',
        flexShrink: 0,
    },
    h3: {
        color: theme.colors.white,
        textAlign: 'center',
        fontSize: '18px',
        fontStyle: 'normal',
        fontWeight: 600,
        lineHeight: 'normal',
        width: '220px',
        height: '17px',
        flexShrink: 0,
        margin: '0px auto 18px',
    },
    li: {
        color: theme.colors.white,
        fontSize: '14px',
        fontStyle: 'normal',
        fontWeight: 400,
        // lineHeight: 'normal',
        lineHeight: '25px' /* 178.571% */,
        flexShrink: 0,
    },
    svgIcon: {
        textAlign: 'center',
    },
    hr: {
        border: '1px solid white',
    },
}));

const Recreation = ({ card }: RecreationCardProps) => {
    const classes = useStyles();
    return (
        <div className={classes.recreationCard}>
            <div className={classes.svgIcon}>
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="66"
                    height="61"
                    viewBox="0 0 66 61"
                    fill="none"
                    className={classes.svg}
                    data-card={card.card}
                >
                    <path
                        d="M54.8339 42.6084V40.4234H63.6781C64.1203 40.4234 64.452 40.2049 64.6731 39.7679C64.8942 39.3309 64.7836 38.8939 64.452 38.5661L60.8037 34.3053H62.0198C62.462 34.3053 62.7937 34.0868 63.0148 33.6497C63.2359 33.2127 63.1253 32.7757 62.7937 32.448L58.261 27.3131H59.4771C59.9193 27.3131 60.251 27.0946 60.4721 26.6576C60.6932 26.2206 60.5826 25.7836 60.251 25.4558L54.3917 18.7914C53.9494 18.3544 53.1756 18.3544 52.7334 18.7914L47.0952 25.6743C46.7635 26.0021 46.7635 26.4391 46.8741 26.8761C46.9846 27.3131 47.4268 27.5316 47.869 27.5316H49.0851L44.5524 32.6665C44.2208 32.9942 44.2208 33.4312 44.3313 33.8682C44.4419 34.3053 44.8841 34.5238 45.3263 34.5238H46.5424L42.8941 38.7846C42.5625 39.1124 42.5625 39.5494 42.673 39.9864C42.7836 40.4234 43.3364 40.4234 43.7786 40.4234H52.6228V42.7177C47.4268 43.1547 41.2359 44.2472 34.8238 46.2138L30.4017 41.8437C30.2911 41.7344 29.1856 40.7511 27.0851 40.4234L29.2961 35.6163L31.065 38.0198L31.1755 38.1291C32.2811 39.2216 33.8288 39.2216 34.3816 39.2216C34.4921 39.2216 34.6027 39.2216 34.6027 39.2216H38.2509C38.3615 39.2216 39.7987 39.2216 40.6831 38.2383C41.2359 37.6921 41.5675 36.9273 41.5675 36.0533C41.5675 33.5405 39.5776 32.6665 38.2509 32.6665H35.4871L31.6177 27.6409C34.8238 26.9853 37.2559 24.254 37.2559 20.8672C37.2559 17.0434 34.1605 13.9843 30.2911 13.9843C26.4217 13.9843 23.3263 17.0434 23.3263 20.8672C23.3263 21.8505 23.5474 22.7245 23.879 23.4893H16.5825C16.472 23.4893 15.477 23.5985 14.482 24.0355C13.7082 24.3633 12.9343 25.1281 12.8237 25.2373L8.06995 30.5907C7.40663 31.2462 6.96442 32.1202 6.96442 32.9942C6.96442 34.8515 8.51216 36.2718 10.281 36.2718C11.3865 36.2718 12.3815 35.7255 12.9343 34.9608L17.0247 30.1537H19.1253L14.2609 39.4401C13.9293 40.2049 13.7082 41.0789 13.7082 41.9529C13.7082 45.012 16.5825 47.634 20.1202 47.634H21.0047L16.6931 51.8949C15.2559 53.4244 13.9293 53.5337 13.9293 53.5337H7.40664C7.29608 53.5337 6.19055 53.4244 6.19055 51.8949C6.19055 50.4746 6.96442 50.2561 7.29608 50.2561H13.9293C14.2609 50.2561 14.482 50.1469 14.7031 49.9283L15.8087 48.8358L14.2609 47.3063L13.4871 48.0711H7.29608C5.96945 48.0711 3.97949 49.1636 3.97949 51.8949C3.97949 54.6262 5.96945 55.6095 7.29608 55.7187H14.0398C14.2609 55.7187 16.2509 55.5002 18.2408 53.5337L24.1001 47.7433H25.869L27.3062 49.2728C21.5574 51.8949 16.3614 55.2817 12.0499 59.324L13.5976 60.9628C17.9092 56.9205 23.1052 53.5337 28.9645 50.9116L32.5022 54.5169C33.0549 55.0632 34.1605 55.6095 35.266 55.6095C36.1504 55.6095 37.0348 55.2817 37.8087 54.5169C38.9142 53.4244 39.2459 52.1134 38.8037 50.8024C38.472 49.9283 37.9193 49.2728 37.8087 49.1636L36.5926 48.0711C51.7384 43.4825 65.6681 44.7935 65.7786 44.7935L65.9997 42.6084C65.6681 42.6084 61.3565 42.1714 54.8339 42.6084ZM49.859 33.9775C50.1906 33.6497 50.1906 33.2127 50.0801 32.7757C49.9695 32.3387 49.5273 32.1202 49.0851 32.1202H47.869L52.4017 26.9853C52.7334 26.6576 52.7334 26.2206 52.6228 25.7836C52.5123 25.3466 52.07 25.1281 51.6278 25.1281H50.4117L53.8389 21.195L57.266 25.1281H55.9394C55.4972 25.1281 55.1655 25.3466 54.9444 25.7836C54.7233 26.2206 54.8339 26.6576 55.1655 26.9853L59.6982 32.1202H58.4821C58.0399 32.1202 57.7082 32.3387 57.4871 32.7757C57.266 33.2127 57.3766 33.6497 57.7082 33.9775L61.3565 38.2383H46.2107L49.859 33.9775ZM34.9343 34.9608H38.2509C38.8037 34.9608 39.3564 35.1793 39.3564 36.1625C39.3564 36.9273 38.8037 37.1458 38.2509 37.1458H34.4921C34.1605 37.1458 33.276 37.1458 32.8338 36.7088L30.4017 33.4312L31.2861 31.4647C31.2861 31.3554 31.2861 31.3554 31.3966 31.2462L34.0499 34.633C34.271 34.8515 34.6027 34.9608 34.9343 34.9608ZM30.1806 16.3879C32.8338 16.3879 34.9343 18.4637 34.9343 21.0857C34.9343 23.7078 32.8338 25.7836 30.1806 25.7836C27.5273 25.7836 25.4268 23.7078 25.4268 21.0857C25.4268 18.4637 27.5273 16.3879 30.1806 16.3879ZM36.1504 52.8782C35.1554 53.8614 34.271 53.2059 33.9394 52.8782L27.0851 45.886C26.864 45.6675 26.6429 45.5583 26.3112 45.5583H20.1202C18.1303 45.5583 15.9192 44.138 15.9192 42.0622C15.9192 41.5159 16.0298 40.9696 16.2509 40.5326L21.668 30.2629H24.5423V28.0779H16.5825C16.2509 28.0779 15.9192 28.1871 15.6981 28.5149L11.276 33.759C11.0549 34.0868 10.7232 34.196 10.3916 34.196C9.72825 34.196 9.28604 33.6497 9.28604 33.1035C9.28604 32.7757 9.39659 32.448 9.72825 32.2295L14.482 27.0946C14.7031 26.8761 15.1453 26.4391 15.477 26.3298C16.0298 26.1113 16.6931 26.0021 16.5825 26.0021H25.2057C25.869 26.6576 26.7534 27.2038 27.7484 27.6409V27.7501C28.5223 27.9686 29.075 28.4056 29.2961 29.0611C29.5172 29.6074 29.5172 30.2629 29.2961 30.6999L24.6529 40.5326H21.0047V42.7177H25.869C27.8589 42.7177 28.8539 43.5917 28.8539 43.5917L36.261 50.9116C36.261 50.9116 36.5926 51.2394 36.7032 51.6764C36.7032 51.7856 36.8137 52.3319 36.1504 52.8782Z"
                        fill="white"
                    />

                    <path
                        d="M27.5277 10.5974C27.9699 10.9252 28.5227 10.9252 28.9649 10.7067L32.7237 7.97537L45.3267 18.3543L46.7639 16.7156L33.4976 5.79032C33.0553 5.46256 32.5026 5.46256 32.1709 5.79032L28.5227 8.52163L19.2362 0.327699C18.794 -0.10931 18.1307 -5.75259e-05 17.6885 0.436952L0 19.0099L1.65829 20.5394L18.4624 2.622L27.5277 10.5974Z"
                        fill="white"
                    />

                    <path
                        d="M53.1751 12.0178C56.4917 12.0178 59.2556 9.28645 59.2556 6.00888C59.2556 2.73131 56.4917 0 53.1751 0C49.8586 0 47.0947 2.73131 47.0947 6.00888C47.0947 9.28645 49.8586 12.0178 53.1751 12.0178ZM53.1751 2.18505C55.2756 2.18505 57.0445 3.93309 57.0445 6.00888C57.0445 8.08467 55.2756 9.83271 53.1751 9.83271C51.0746 9.83271 49.3058 8.08467 49.3058 6.00888C49.3058 3.93309 51.0746 2.18505 53.1751 2.18505Z"
                        fill="white"
                    />
                </svg>
            </div>
            <hr className={classes.hr} />
            <h3 className={classes.h3}>{card.header}</h3>
            <ul>
                {card.list.map((item) => (
                    <li
                        className={classes.li}
                        key={`${card.card}-${Math.random()}`}
                    >
                        {item.desc}
                    </li>
                ))}
            </ul>
        </div>
    );
};

export default Recreation;
